/* ===========================================================
   TEMPEST & THE RABBIT — THEME JAVASCRIPT
   ===========================================================
   Handles: navigation menu, FAQ accordion, subscription tier
   selection, variant ID binding, and scroll-triggered fade-ins.
   =========================================================== */

(function () {
  'use strict';

  /* -------------------------------------------
     HAMBURGER MENU TOGGLE
     ------------------------------------------- */
  const hamburger = document.getElementById('hamburger');
  const navMenu = document.getElementById('navMenu');
  const menuOverlay = document.getElementById('menuOverlay');

  function toggleMenu() {
    const isOpen = navMenu.classList.toggle('open');
    menuOverlay.classList.toggle('open');
    hamburger.setAttribute('aria-expanded', isOpen);
  }

  if (hamburger) {
    hamburger.addEventListener('click', toggleMenu);
  }
  if (menuOverlay) {
    menuOverlay.addEventListener('click', toggleMenu);
  }
  // Nav dropdown toggle
document.querySelectorAll('.nav-dropdown-toggle').forEach(toggle => {
  toggle.addEventListener('click', function() {
    this.classList.toggle('open');
    const items = this.nextElementSibling;
    items.classList.toggle('open');
    this.setAttribute('aria-expanded', items.classList.contains('open'));
  });
});

  // Close menu when a nav link is clicked
  if (navMenu) {
    navMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        if (navMenu.classList.contains('open')) {
          toggleMenu();
        }
      });
    });
  }

  // Close menu on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && navMenu && navMenu.classList.contains('open')) {
      toggleMenu();
    }
  });


  /* -------------------------------------------
     FAQ ACCORDION
     ------------------------------------------- */
  document.querySelectorAll('.faq-question').forEach(function (question) {
    question.addEventListener('click', function () {
      var item = this.parentElement;
      var wasOpen = item.classList.contains('open');

      // Close all FAQ items
      document.querySelectorAll('.faq-item').forEach(function (faqItem) {
        faqItem.classList.remove('open');
        var btn = faqItem.querySelector('.faq-question');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });

      // Open clicked item if it was closed
      if (!wasOpen) {
        item.classList.add('open');
        this.setAttribute('aria-expanded', 'true');
      }
    });

    // Keyboard accessibility for FAQ
    question.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  });


  /* -------------------------------------------
     SUBSCRIPTION TIER SELECTION
     Clicking a tier card updates the hidden
     variant ID input for the add-to-cart form.
     ------------------------------------------- */
  document.querySelectorAll('.tier').forEach(function (tier) {
    tier.addEventListener('click', function () {
      // Remove selected from all tiers
      document.querySelectorAll('.tier').forEach(function (t) {
        t.classList.remove('selected');
      });
      // Select this one
      this.classList.add('selected');

      // If using Shopify product variants, update hidden input
      var variantId = this.getAttribute('data-variant-id');
      if (variantId) {
        var hiddenInput = document.getElementById('subscription-variant-id');
        if (hiddenInput) {
          hiddenInput.value = variantId;
        }
      }
    });
  });


  /* -------------------------------------------
     SCROLL-TRIGGERED FADE-IN ANIMATIONS
     Uses IntersectionObserver for performance.
     ------------------------------------------- */
  if ('IntersectionObserver' in window) {
    var fadeObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -40px 0px',
      }
    );

    document.querySelectorAll('.fade-in').forEach(function (el) {
      fadeObserver.observe(el);
    });
  } else {
    // Fallback: show all elements immediately
    document.querySelectorAll('.fade-in').forEach(function (el) {
      el.classList.add('visible');
    });
  }
// Carousel
function initCarousel() {
  const imgs = document.querySelectorAll('.carousel-img');
  const thumbs = document.querySelectorAll('.carousel-thumb');
  const prev = document.querySelector('.carousel-prev');
  const next = document.querySelector('.carousel-next');
  
  if (!imgs.length) return;
  
  let current = 0;

  function goTo(index) {
    imgs[current].classList.remove('active');
    thumbs[current].classList.remove('active');
    current = (index + imgs.length) % imgs.length;
    imgs[current].classList.add('active');
    thumbs[current].classList.add('active');
  }

  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', () => goTo(i));
  });

  if (prev) prev.addEventListener('click', () => goTo(current - 1));
  if (next) next.addEventListener('click', () => goTo(current + 1));
}

document.addEventListener('DOMContentLoaded', initCarousel);

})();

// Announcement banner dismiss
const announcementBar = document.getElementById('announcementBar');
const announcementClose = document.getElementById('announcementClose');

if (announcementClose && announcementBar) {
  announcementClose.addEventListener('click', function() {
    announcementBar.classList.add('hidden');
    sessionStorage.setItem('announcementDismissed', 'true');
    document.querySelector('.nav').style.top = '0';
  });

  if (sessionStorage.getItem('announcementDismissed') === 'true') {
  announcementBar.classList.add('hidden');
  document.querySelector('.nav').style.top = '0';
}
}
